"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = exports.resolvePrefix = void 0;
var resolvePrefix_1 = require("./resolvePrefix");
Object.defineProperty(exports, "resolvePrefix", { enumerable: true, get: function () { return resolvePrefix_1.resolvePrefix; } });
var logger_1 = require("./logger");
Object.defineProperty(exports, "logger", { enumerable: true, get: function () { return logger_1.logger; } });
